import { Form, Select, Space, InputNumber, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { Text } from "ui/Typography"
import styles from "./PrivateCutOff.module.css"

const CUT_OFF_UNIT_OPTIONS = [
  { value: "minute", label: "minutes before start" },
  { value: "hour", label: "hours before start" },
  { value: "day", label: "days before start" },
]

export const PrivateCutOff = () => {
  const { t } = useTranslation()

  return (
    <Card title={t("listings.tabs.scheduling.sections.cut_off.title")} className="mb-3xl">
      <Form.Item
        label={
          <div className={styles.label}>
            <Text>{t("listings.tabs.scheduling.sections.cut_off.label")}</Text>
            <Tooltip title={t("listings.tabs.scheduling.sections.cut_off.label")}>
              <InfoCircleOutlined className={styles.infoIcon} />
            </Tooltip>
          </div>
        }
        required
        className="mb-0"
      >
        <Space.Compact>
          <Form.Item
            name="cut_off_value"
            noStyle
            rules={[{ required: true, message: "Cut off value is required" }]}
          >
            <InputNumber min={0} className={styles.numberInput} />
          </Form.Item>
          <Form.Item
            name="cut_off_unit"
            noStyle
            rules={[{ required: true, message: "Cut off unit is required" }]}
          >
            <Select options={CUT_OFF_UNIT_OPTIONS} className={styles.unitSelect} />
          </Form.Item>
        </Space.Compact>
      </Form.Item>
    </Card>
  )
}
